function SignAdvantageItem({ title, description, image }) {
  return (
    <div className="flex font-sans tracking-wider items-center my-5">
      <div className="flex-shrink-0 text-3xl">{image}</div>
      <div className="ml-5">
        <div className="font-bold text-lg mb-2">{title}</div>
        <div className="text-base font-normal font-sans">{description}</div>
      </div>
    </div>
  )
}

export default SignAdvantageItem
